var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1295 19.25V17.4167C18.1295 16.4442 17.7432 15.5116 17.0555 14.8239C16.3679 14.1363 15.4353 13.75 14.4628 13.75H8.96281C7.99035 13.75 7.05772 14.1363 6.37008 14.8239C5.68245 15.5116 5.29614 16.4442 5.29614 17.4167V19.25",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7128 10.0833C13.7379 10.0833 15.3795 8.44171 15.3795 6.41667C15.3795 4.39162 13.7379 2.75 11.7128 2.75C9.68777 2.75 8.04614 4.39162 8.04614 6.41667C8.04614 8.44171 9.68777 10.0833 11.7128 10.0833Z",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUse);
export default __webpack_public_path__ + "static/media/use.80b4b248487b36c68cb41b990ddfbb94.svg";
export { ForwardRef as ReactComponent };